module.exports = __webpack_public_path__ + "img/element_1.5cb92686.png";